import { ordersBasketApiConnector } from 'apiConnector/orders-basket';
import type { ReloadFormRequest } from 'epic/common-form/ReloadFormRequest';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, mergeMap, take, withLatestFrom } from 'rxjs/operators';
import type { SpEpic } from 'shared/middlewares/epic/epicMiddleware.factory';
import { ordersBasketFormInitializationFailed } from 'state/orders-basket/actions';
import { ordersBasketInitFormFailedThunk } from 'state/orders-basket/import-spreadsheet/thunks';
import {
  newOrdersBasketFormRequestedThunk,
  ordersBasketFormInitializedThunk,
  ordersBasketImportFailedThunk,
  ordersBasketImportReceivedThunk,
} from 'state/orders-basket/thunks';
import { isFeatureEnabled } from 'state/selectors';
import type { EpicWithThunk } from 'state/state.common';

// TODO: Fix skipped test cases
export function addToOrdersBasketEpic(): SpEpic {
  return actions$ =>
    actions$.pipe(ofType('ORDERS_BASKET_TAB_CONTENT_ALL_FETCHED'), take(1)).pipe(
      mergeMap(() =>
        actions$.pipe(
          ofType('ADD_TO_ORDERS_BASKET'),
          map(action =>
            newOrdersBasketFormRequestedThunk(
              action.quoteId,
              action.wrapper,
              action.productType,
              action.productSubType,
              action.tabName,
              action.processingChain,
              action.pricerRfqId,
              action.productId,
            ),
          ),
        ),
      ),
    );
}

import { getOrdersBasketInitializeFormRequest } from 'state/orders-basket/selectors';

export function newOrdersBasketFormRequestedEpic(): EpicWithThunk {
  return (actions$, state$, { oldHttpClient, frontLogger }) =>
    actions$.pipe(
      ofType('NEW_ORDERS_BASKET_FORM_REQUESTED'),
      withLatestFrom(state$),
      mergeMap(([action, state]) => {
        const isReloadTessaQuotesInOrdersBasketHKEnabled = isFeatureEnabled(state, 'reloadTessaQuotesInOrdersBasketHK');
        const baseParams: ReloadFormRequest = {
          id: action.id,
          idType: action.idType,
          tradeDate: action.tradeDate,
          processingChain: action.processingChain,
        };
        const params = isReloadTessaQuotesInOrdersBasketHKEnabled
          ? { ...baseParams, pricerRfqId: action.pricerRfqId }
          : baseParams;
        const request = getOrdersBasketInitializeFormRequest(state, params);

        return ordersBasketApiConnector(oldHttpClient)
          .reloadForm(request)
          .pipe(
            map(result => ordersBasketFormInitializedThunk(action.tabId, action.temporaryNegotiationId, result)),
            catchError((error: Error) => {
              frontLogger.error('An error occurred inside newOrdersBasketFormRequestedEpic {@FrontError}', error);
              return of(ordersBasketFormInitializationFailed(action.temporaryNegotiationId));
            }),
          );
      }),
    );
}

export function ordersBasketImportRequestedEpic(): EpicWithThunk {
  return (actions$, state$, { oldHttpClient, frontLogger }) =>
    actions$.pipe(
      ofType('ORDERS_BASKET_IMPORT_REQUESTED'),
      withLatestFrom(state$),
      mergeMap(([action, _]) => {
        const request: ReloadFormRequest = action.request;
        return ordersBasketApiConnector(oldHttpClient)
          .reloadForm(request)
          .pipe(
            map(result =>
              ordersBasketImportReceivedThunk(
                result,
                request.id,
                action.productVariation,
                action.temporaryNegotiationId,
              ),
            ),
            catchError((error: Error) => {
              frontLogger.error('An error occurred inside ordersBasketImportRequestedEpic {@FrontError}', error);
              return of(ordersBasketImportFailedThunk(action.tabId, action.temporaryNegotiationId, request.id, error));
            }),
          );
      }),
    );
}

export function ordersBasketInitFormRequestedEpic(): EpicWithThunk {
  return (actions$, state$, { oldHttpClient, frontLogger }) =>
    actions$.pipe(
      ofType('ORDERS_BASKET_INIT_FORM_REQUESTED'),
      withLatestFrom(state$),
      mergeMap(([action, _]) => {
        const request = action.request;
        return ordersBasketApiConnector(oldHttpClient)
          .ImportForm(request)
          .pipe(
            map(result => ordersBasketFormInitializedThunk(action.tabId, action.temporaryNegotiationId, result)),
            catchError((error: Error) => {
              frontLogger.error('An error occurred inside ordersBasketInitFormRequestedEpic {@FrontError}', error);
              return of(ordersBasketInitFormFailedThunk(action.tabId, action.temporaryNegotiationId));
            }),
          );
      }),
    );
}
